// Keeps the "What's in the set" block (snippets/set-contents.liquid) in sync with
// the selected variant by swapping in the copy Dawn re-renders on variant change.
if (!customElements.get('set-contents')) {
  customElements.define(
    'set-contents',
    class SetContents extends HTMLElement {
      connectedCallback() {
        this.experience = this.closest('[data-gw-pdp-experience="test"]');
        this.unsubscribeOptionChange = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
          if (!this.closest('product-info')?.contains(data.event.target)) return;
          this.experience?.classList.add('gw-set--unavailable');
        });
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.dataset.section) return;
          const updated = data.html.getElementById(this.id);
          if (updated) {
            this.innerHTML = updated.innerHTML;
            this.experience?.classList.remove('gw-set--unavailable');
          }
        });
      }

      disconnectedCallback() {
        this.unsubscribe?.();
        this.unsubscribeOptionChange?.();
      }
    }
  );
}
